module.exports = __webpack_public_path__ + "static/g-9-5043712599e20de32820c6491703cdde.jpg";